/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractFinderGridDefinition } from '@gh/common-internal-shared';
import { NumberTypes } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { buildNumberColumn } from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { getPbHousePlanId } from '../../resources/house-plan-finder.model';

@Injectable()
export class PbHousePlanFinderGridDefinition extends AbstractFinderGridDefinition {
  getId = getPbHousePlanId;

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      { field: 'code', headerName: this.translationService.get('lbl_code'), width: 250 },
      { field: 'name', headerName: this.translationService.get('lbl_description'), width: 350 },
      {
        field: 'salesPrice',
        headerName: this.translationService.get('lbl_price'),
        width: 100,
        ...buildNumberColumn(NumberTypes.Price),
      },
    ];
  }

}
